import React from 'react'
import NavBar from '../landing/navbar'
import Footer from '../landing/footer'
import './faq.scss'
import Chatwoot from '../../components/chat/chatwoot'
import ContentPageHeader from '../../components/ui/contentPageHeader'
import FaqContent from './FaqContent'
import { useAuth } from '../../context/auth'
import Button from '../../components/ui/button'

const Faq = () => {
  const { user } = useAuth()

  const BackButton = <Button as='link' to='/' className='faq-back'>← Back to {user ? 'Dashboard' : 'Home'}</Button>
  return (
    <div className='faq-page'>
      <NavBar />
      <Chatwoot />
      <main className='container col-xxl-5 py-5'>
        {BackButton}
        <ContentPageHeader
          title='Frequently asked questions'
          subtitle='Everything you need to know about TinyInvoice.app'
        />
        <FaqContent />
        {BackButton}
      </main>
      <Footer />
    </div>
  )
}

export default Faq
